import React from 'react'
import Routes from '../../../constants/routes'
import { Badge, Card } from 'antd'
import Text from 'antd/es/typography/Text'
import { sqlToJsDate, sqlToTimeFromNow } from '../../../utils/date.helper'
import { Link } from 'react-router-dom'
import { NOTIFICATION_TYPES } from '../../../constants/notification-types'
import { getActionsFromType, getMessageFromType } from '../../../utils/notification.helper'

const NotificationItem = ({ id, message: messageProp, url, read, createdAt, type, payload }) => {
    const classNames = ['notification-item-card']
    if (!read) classNames.push('notification-item-card-unseen')
    if (type === NOTIFICATION_TYPES.SUCCESS) classNames.push('notification-item-card-success')
    if (type === NOTIFICATION_TYPES.WARNING) classNames.push('notification-item-card-warning')
    if (type === NOTIFICATION_TYPES.ERROR) classNames.push('notification-item-card-error')

    const message = type === NOTIFICATION_TYPES.ACTION ? getMessageFromType(payload.action, payload) : messageProp

    const actions = getActionsFromType(payload?.action, payload, url)
    const isExternalUrl = Boolean(url && /^https?:\/\//i.test(url))

    const card = (
        <Badge className='f-width' dot count={read ? 0 : 1}>
            <Card className={classNames.join(' ')} seen={String(read)} size='small'>
                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                    <div style={{ flex: '1 1 auto', minWidth: '0' }}>
                        <Text className='mr-8'>{message}</Text>
                        <Text type='secondary' title={sqlToJsDate(createdAt)}>
                            {sqlToTimeFromNow(createdAt)}
                        </Text>
                    </div>
                    {actions && <div style={{ flex: '0 0 auto', marginLeft: 'auto' }}>{actions}</div>}
                </div>
            </Card>
        </Badge>
    )

    if (isExternalUrl) {
        return <div key={id}>{card}</div>
    }

    return (
        <Link to={url || Routes.HOME} key={id} alt={message}>
            {card}
        </Link>
    )
}

export default NotificationItem
